import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-tecnologie.webp';

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <img src={logo} alt="Tecnologie" className="h-10 w-auto" />
              <div>
                <div className="font-bold text-slate-900">Tecnologie srl</div>
                <div className="text-xs text-[#0d63b0] font-semibold uppercase tracking-wider">Secure Push</div>
              </div>
            </div>
            <p className="mt-4 text-sm text-slate-600 max-w-md leading-relaxed">
              Servizio sicuro per la condivisione di password, file e URL riservati. I link
              si auto-distruggono dopo la visualizzazione o alla scadenza impostata.
            </p>
            <div className="mt-6 space-y-2 text-sm text-slate-600">
              <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#0d63b0]" /> 045.4770241</div>
              <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#0d63b0]" /> info@tecnologieverona.it</div>
              <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#0d63b0]" /> Verona, Italia</div>
            </div>
          </div>
          <div>
            <div className="text-sm font-semibold text-slate-900 mb-4">Servizio</div>
            <ul className="space-y-2 text-sm text-slate-600">
              <li><Link to="/p/new" className="hover:text-[#0d63b0]">Crea Push</Link></li>
              <li><Link to="/dashboard" className="hover:text-[#0d63b0]">I miei push</Link></li>
              <li><Link to="/pricing" className="hover:text-[#0d63b0]">Piani e prezzi</Link></li>
              <li><Link to="/features" className="hover:text-[#0d63b0]">Funzionalità</Link></li>
              <li><Link to="/register" className="hover:text-[#0d63b0]">Registrati</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-sm font-semibold text-slate-900 mb-4">Sicurezza</div>
            <ul className="space-y-2 text-sm text-slate-600">
              <li>Cifratura AES-256</li>
              <li>Nessun tracciamento</li>
              <li>Auto-eliminazione</li>
              <li>Conforme GDPR</li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-slate-500">© {new Date().getFullYear()} Tecnologie srl · Soluzioni per l'informatica a Verona</div>
          <div className="text-xs text-slate-500">Powered by Password Pusher · Personalizzato per Tecnologie</div>
        </div>
      </div>
    </footer>
  );
}
